import { Layer } from "effect"
import { AppHttpClient } from "@/shared/scope"
import { RpcClient, RpcSerialization } from "@effect/rpc"
import { createEffectQueryNoAbort } from "@/lib/api/effect-query-utils"
import { FeatureAnnouncementsUserRpc } from "@/presentation/rpc/feature-announcements-rpc"

/**
 * Co-located effect-query client for the user-facing feedback conversation RPCs.
 *
 * These methods live on the EXISTING FeatureAnnouncementsUserRpc group (same
 * route as submit-feedback), but the client is built here — NOT added to the
 * legacy `src/lib/effect-query.ts` monolith, which is frozen for new code.
 */
const FeatureAnnouncementsUserRpcLive = RpcClient.layerProtocolHttp({
  url: "/api/rpc/feature-announcements",
}).pipe(
  Layer.provide(AppHttpClient.layer),
  Layer.provideMerge(RpcSerialization.layerJson),
)

export const myFeedbackEq = createEffectQueryNoAbort(FeatureAnnouncementsUserRpcLive)

export { FeatureAnnouncementsUserRpc }
